module.exports = __webpack_public_path__ + "media/images/static-1-6d3f1bed79cef8485e7616b6c51be4e2.jpg";